module.exports = __webpack_public_path__ + "static/img/pitch_black_old.e1dad61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_black_old.png
// module id = o2/A
// module chunks = 94